import React, { useState } from 'react';
import { connect } from 'react-redux';
import { decrementLinkId, incrementLinkId } from '../../../../../../../_actions/document-builder.actions';

import { moveItem, setWarning } from '../../../../../../../_actions/questionnaire.actions'

const Position = ({ question, position, count, dispatch }) => {
  const [humanPosition, setHumanPosition] = useState(position + 1);

  return <div className="form-group">
    <label htmlFor="question"><strong>Position</strong></label>
    <div className="input-group">
      <input onChange={(e) => setHumanPosition(e.target.value)} value={humanPosition} type="number" min="1" max={count} className="form-control" />
      <div className="input-group-append">
        <button onClick={(e) => {
          dispatch(setWarning());
          dispatch(moveItem(position, humanPosition));

          const to = parseInt(humanPosition) - 1;
          const from = position;

          if (to < from) {
            dispatch(incrementLinkId(to, from))
          } else {
            dispatch(decrementLinkId(to, from));
          }
        }} className="btn btn-outline-secondary" type="button">
          <i className="fa fa-arrows-v" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </div>
}

const mapStateToProps = state => {
  return {
    count: state.questionnaire.current.item.length
  }
}

export default connect(mapStateToProps)(Position)